import { configureStore } from "@reduxjs/toolkit";
import notifySlice from "./notification-slice";
import userSlice from "./user-slice";
import cartSlice from "./cart-slice";
import accessNoticesSlice from "./accessNoticesSlice";

const appReduxStore = configureStore({
  reducer: {
    notify: notifySlice.reducer,
    user: userSlice.reducer,
    cart: cartSlice.reducer,
    accessNotices: accessNoticesSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default appReduxStore;
